import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenService } from '@processo/services/token.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private tokenService: TokenService) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const idToken = this.tokenService.getIdToken();
    const access_token = this.tokenService.getAccessToken();
    
    let modifiedReq = req;
    if (idToken && access_token)  {
      modifiedReq = req.clone({
        setHeaders: {
          Authorization: `${access_token}`,
          id_token:`${idToken}`,
        },
      });
    }
    //  else if (idToken) {
    //   modifiedReq = req.clone({
    //     setHeaders: {
    //       idToken: `${idToken}`,
    //     },
    //   });
    // }

    return next.handle(modifiedReq);
  }
}

